module.exports = "pegasus/assets/preview-23.png";